import { useState } from "react";
import { useNavigate } from "react-router";
import toast from "react-hot-toast";
import Auth_API from "../services/auth";
import AuthService from "../services/authService";
import Modal from "./Modal";
import { useAtom } from "jotai";
import { isLogoutState } from "../global/jotaiState";
import { ErrorConstants } from "../constants/ErrorConstants";
import LogoutService from "../services/AuthLogout";

// eslint-disable-next-line react/prop-types
export default function Logout() {
  const navigate = useNavigate();

  const [isLogout, setIsLogout] = useAtom(isLogoutState);

  const handleLogout = async () => {
    try {
      const option = {
        deviceId: AuthService.getDeviceId(),
        storeName: AuthService.getShopName(),
        storeId: AuthService.getStoreId(),
      };

      const response = await LogoutService.postLogout(option);
      if (response) {
        toast.success("Logout Successful");
        AuthService.logout();
        setIsLogout(false);
        navigate("/login", { replace: true });
      }
    } catch (error) {
      toast.error(
        error?.errorResponse?.message || ErrorConstants.UNABLE_TO_LOGOUT
      );
    }
  };

  if (!isLogout) return;

  return (
    <Modal open={isLogout}>
      <div className="p-10">
        <div className="p-2">
          <p className="mb-2 font-bold text-center">
            Are you sure you want to logout this session?
          </p>

          <div className="flex space-x-6 mt-5">
            <button
              onClick={() => setIsLogout(false)}
              className="w-full !mt-3 text-primary-300 border border-primary-300 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Cancel
            </button>

            <button
              onClick={() => handleLogout()}
              className="w-full !mt-3 text-white bg-primary-300 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
